



























import {Component, Mixins, Prop} from 'vue-property-decorator';
import {RouteConfig} from 'vue-router';

import RippleEffect from '@/mixins/RippleEffect';

@Component({})
export default class Button extends Mixins(RippleEffect) {
	@Prop({default: null}) readonly variant?: string | null;
	@Prop({default: null}) readonly size?: string | null;
	@Prop({default: 'body-paragraph'}) readonly labelVariant?: string;
	@Prop({default: () => ([])}) readonly classes?: Array<string>;
	@Prop({default: false}) readonly disabled!: boolean;
	@Prop({default: null}) readonly href?: string | null;
	@Prop({default: null}) readonly to?: string | RouteConfig | null;
	@Prop({default: 'button'}) readonly element?: string | null;
	@Prop({default: null}) readonly target?: string | null;
	@Prop({default: null}) readonly iconName?: string | null;
	@Prop({default: () => ({})}) readonly onClick?: Function | null;
	@Prop({required: false, default: true}) readonly awaitRipple?: boolean;
	@Prop({required: false, default: false}) readonly isLoading?: boolean;

	get classList(): (string | null)[] {
		return [
			'button',
			this.size ? `button--${this.size}` : null,
			this.isLoading ? 'is-loading' : null,
			...(this.classes || [])
		]
	}

	get variantClasses(): Array<string> | null {
		if (!this.variant) {
			return null;
		}

		return this.variant.split(' ').map((variant) => {
			return `button--${variant}`
		});
	}

	async clickWithRipple(event: MouseEvent): Promise<void> {
		if (this.awaitRipple) {
			await this.startRipple(event);
		} else {
			this.startRipple(event);
		}

		if (typeof this.onClick !== 'function') {
			return;
		}

		this.onClick ? this.onClick(event) : null;
	}
}
